module.exports = __webpack_public_path__ + "static/media/car-building.f1f6d742.svg";